import { render, staticRenderFns } from "./PropertyCardKey.vue?vue&type=template&id=5e04ef1b&"
import script from "./PropertyCardKey.vue?vue&type=script&lang=js&"
export * from "./PropertyCardKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports